import * as React from 'react';
import { useState } from 'react';

/** Material UI Packages. */
import { FormGroup, FormControlLabel, Checkbox } from '@mui/material';

const AfternoonSelector = ({ status, onChange }) => {
    return (
        <FormGroup sx={{ display: 'inline', px: 1 }}>
            <FormControlLabel
                control={
                    <Checkbox size="small" name="beforeNoon" checked={status.afternoon === false} onChange={onChange} />
                }
                label="Before noon"
                sx={{
                    gap: '5px',
                    '& .MuiFormControlLabel-label': {
                        fontSize: '10px',
                        fontWeight: 500,
                        color: '#003a52',
                    },
                }}
            />
            <FormControlLabel
                control={
                    <Checkbox size="small" name="afternoon" checked={status.afternoon === true} onChange={onChange} />
                }
                label="Afternoon"
                sx={{
                    gap: '5px',
                    '& .MuiFormControlLabel-label': {
                        fontSize: '10px',
                        fontWeight: 500,
                        color: '#003a52',
                    },
                }}
            />
        </FormGroup>
    );
};

export default AfternoonSelector;
